var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"bx--row info-section"},[_c('div',{staticClass:"bx--col-md-8 bx--col-lg-4 bx--col-xlg-3"},[_c('h3',{staticClass:"info-section__heading"},[_vm._v(_vm._s(_vm.heading))])]),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }